const config = {
    apiUrl: 'https://profinance.pro/api',
    // apiUrl: 'http://localhost:3333/api',
    apiTdsReportsUrl: '/var/www/html/site-eg-bot/public/files/tds'
}

export default config;
